import _ from 'lodash';

// The "לערוך" actions DailyRoutineViewer can open.
export const DAILY_ROUTINE_ACTION_TYPES = {
  TRANSACTION_MENU: 'transaction_menu',
  CATEGORY_AMOUNT_SET: 'category_amount_set',
};

// The card types this app shows: the ones sumsum served before elsa-v3's daily-routine cards
// (sumsum#225). sumsum serves the same list to both apps, and every newer type is for elsa-v3
// only, so a type missing here isn't shown (the special cards are handled on their own).
const VUE2_CARD_TYPES = [
  'NEW_TRANSACTION_CATEGORIZATION',
  'CATEGORY_EXCEEDED',
  'CATEGORY_ABOUT_TO_EXCEED',
  'INCOME_EXCLUSION',
  'EXPENSE_EXCLUSION',
  'SIGNIFICANT_FIXED_INCOME_HIGHER_THAN_PREVIOUS',
  'SIGNIFICANT_FIXED_INCOME_LOWER_THAN_PREVIOUS',
  'SIGNIFICANT_FIXED_INCOME_SAME_AS_PREVIOUS',
  'FAR_FROM_PREDICTION',
  'FIXED_BALANCE',
  'LAST_INSTALLMENT',
];

export function isViewerCard(card) {
  return _.includes(VUE2_CARD_TYPES, card.type);
}
